// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  linkId: __t.u64().primaryKey().name("link_id"),
  twinId: __t.string().name("twin_id"),
  streamName: __t.string().name("stream_name"),
  telemetryName: __t.string().name("telemetry_name"),
  dtdlTelemetryId: __t.u64().name("dtdl_telemetry_id"),
  componentInstanceId: __t.option(__t.u64()).name("component_instance_id"),
});
